import type { FeedbackMessages } from './en';

const tr: FeedbackMessages = {
  qualified: {
    title: 'Bu araştırmayı tamamladığınız için teşekkür ederiz!',
    text: 'Tarayıcı penceresini kapatabilirsiniz.\n\nSizi yakında yeniden görmeyi umuyoruz.',
  },
  quotaFull: {
    title: 'Bu araştırma kapatılmıştır',
    text: 'Araştırmamıza gösterdiğiniz ilgi için teşekkür ederiz.\n\nNe yazık ki ihtiyacımız olan tüm yanıtları zaten aldık.\n\nSizi gelecekteki araştırmalarımızdan birinde görmeyi umuyoruz!',
  },
  terminated: {
    title: 'Geri bildiriminizi paylaştığınız için teşekkür ederiz!',
    text: 'Sizi gelecekteki araştırmalarımızda yakında görmeyi umuyoruz. O zamana kadar size iyi günler dileriz.\n\nLütfen bu tarayıcı penceresini kapatın.',
  },
  mismatch: {
    title: 'İlginiz için teşekkür ederiz',
    text: 'Ne yazık ki, bu özel araştırma için hedef grupta değilsiniz.\n\nBu sayfayı kapatabilirsiniz.',
  },
  error: {
    title: 'Talebinizi karşılayamıyoruz',
    linkProblemDetailed:
      'Takip ettiğiniz bağlantıda bir sorun var. Lütfen adres satırındaki bağlantının size verilenle eşleştiğini kontrol edin ve tekrar deneyin.',
    linkProblemGeneric:
      'Takip ettiğiniz bağlantıda bir sorun var. Lütfen tekrar deneyin.',
    contactPerson:
      'Sorun devam ederse, lütfen bağlantıyı aldığınız kişiye bu sorunu bildirin.',
  },
};

export default tr;
